// ADMIN HISTORY

export const GET_ADMIN_HISTORY = "GET_ADMIN_HISTORY";

// USER HISTORY
export const GET_USER_HISTORY = "GET_USER_HISTORY";
